(function(){
  var money = function(cents){
    var fmt = (window.DaivaShop && window.DaivaShop.moneyFormat) || 'Rs. {{amount}}';
    var v = (cents/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var v0 = Math.round(cents/100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, v0).replace(/\{\{\s*amount\s*\}\}/, v);
  };
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* hero video pause */
  document.querySelectorAll('[data-hero-pause]').forEach(function(btn){
    var v = btn.parentElement.querySelector('video');
    if(!v) { btn.hidden = true; return; }
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { v.pause(); btn.textContent = 'Play'; }
    btn.addEventListener('click', function(){
      if (v.paused) { v.play(); btn.textContent = 'Pause'; } else { v.pause(); btn.textContent = 'Play'; }
    });
  });

  /* mobile menu */
  var mt = document.querySelector('[data-menu-toggle]');
  var mm = document.querySelector('[data-mobile-menu]');
  if (mt && mm) {
    mt.addEventListener('click', function(){
      var open = mm.hasAttribute('open');
      if (open) { mm.removeAttribute('open'); } else { mm.setAttribute('open',''); }
      mt.setAttribute('aria-expanded', String(!open));
      document.body.style.overflow = open ? '' : 'hidden';
    });
  }

  /* dialogs */
  document.addEventListener('click', function(e){
    var opener = e.target.closest('[data-open-dialog]');
    if (opener) { var d = document.getElementById(opener.getAttribute('data-open-dialog')); if (d) { e.preventDefault(); d.showModal(); } }
    var closer = e.target.closest('[data-close-dialog]');
    if (closer) { var dd = closer.closest('dialog'); if (dd) dd.close(); }
    if (e.target.tagName === 'DIALOG') e.target.close();
  });

  /* cart drawer */
  var drawer = document.getElementById('CartDrawer');
  function setCount(n){ document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = n; el.hidden = n < 1; }); }
  function renderDrawer(open){
    return fetch(root + '?section_id=dv-cart-drawer').then(function(r){ return r.text(); }).then(function(html){
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var fresh = doc.querySelector('[data-drawer-inner]');
      var cur = drawer && drawer.querySelector('[data-drawer-inner]');
      if (fresh && cur) cur.replaceWith(fresh);
      var c = doc.querySelector('[data-count]');
      if (c) setCount(parseInt(c.getAttribute('data-count'),10)||0);
      if (open && drawer && !drawer.open) drawer.showModal();
    });
  }
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-open-cart]');
    if (t && drawer) { e.preventDefault(); renderDrawer(true); }
  });
  function changeLine(key, qty){
    return fetch(root + 'cart/change.js', {method:'POST', headers:{'Content-Type':'application/json','Accept':'application/json'}, body: JSON.stringify({id:key, quantity:qty})}).then(function(){ return renderDrawer(false); });
  }
  if (drawer) {
    drawer.addEventListener('click', function(e){
      var b = e.target.closest('[data-qty]');
      if (b) { var key = b.getAttribute('data-key'); var q = parseInt(b.getAttribute('data-qty'),10); changeLine(key, q); }
    });
  }

  /* product form */
  document.querySelectorAll('[data-product]').forEach(function(wrap){
    var dataEl = wrap.querySelector('[data-product-json]');
    if (!dataEl) return;
    var product = JSON.parse(dataEl.textContent);
    var form = wrap.querySelector('form[data-product-form]');
    var idInput = form.querySelector('input[name="id"]');
    var btns = document.querySelectorAll('[data-atc]');
    var priceEl = wrap.querySelector('[data-price]');
    var cmpEl = wrap.querySelector('[data-compare]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var msg = wrap.querySelector('[data-form-msg]');

    function selected(){
      return Array.prototype.map.call(wrap.querySelectorAll('fieldset[data-option]'), function(fs){
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    function find(opts){
      return product.variants.find(function(v){ return v.options.every(function(o,i){ return o === opts[i]; }); });
    }
    function markAvailability(opts){
      wrap.querySelectorAll('fieldset[data-option]').forEach(function(fs, idx){
        fs.querySelectorAll('input').forEach(function(inp){
          var test = opts.slice(); test[idx] = inp.value;
          var v = find(test);
          inp.classList.toggle('is-unavailable', !v || !v.available);
        });
        var lab = fs.querySelector('[data-option-value]'); var c = fs.querySelector('input:checked');
        if (lab && c) lab.textContent = c.value;
      });
    }
    function update(){
      var opts = selected(); var v = find(opts);
      markAvailability(opts);
      btns.forEach(function(b){
        if (!v) { b.disabled = true; b.textContent = 'Unavailable'; }
        else if (!v.available) { b.disabled = true; b.textContent = 'Sold out'; }
        else { b.disabled = false; b.textContent = 'Add to cart'; }
      });
      if (!v) return;
      idInput.value = v.id;
      if (priceEl) priceEl.textContent = money(v.price);
      if (stickyPrice) stickyPrice.textContent = money(v.price);
      if (cmpEl) { if (v.compare_at_price && v.compare_at_price > v.price) { cmpEl.textContent = money(v.compare_at_price); cmpEl.hidden = false; } else { cmpEl.hidden = true; } }
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }
    wrap.addEventListener('change', function(e){ if (e.target.closest('fieldset[data-option]')) update(); });
    update();

    form.addEventListener('submit', function(e){
      if (!drawer || !window.fetch) return;
      e.preventDefault();
      btns.forEach(function(b){ b.disabled = true; b.textContent = 'Adding'; });
      fetch(root + 'cart/add.js', {method:'POST', headers:{'Accept':'application/json'}, body: new FormData(form)})
        .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, j:j}; }); })
        .then(function(res){
          if (!res.ok) { if (msg) { msg.textContent = res.j.description || 'Could not add to cart. Try another size.'; msg.hidden = false; } update(); return; }
          if (msg) msg.hidden = true; update(); renderDrawer(true);
        })
        .catch(function(){ form.submit(); });
    });

    var sticky = document.querySelector('[data-sticky-atc]');
    var mainBtn = form.querySelector('[data-atc]');
    if (sticky && mainBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function(entries){ entries.forEach(function(en){ sticky.classList.toggle('is-on', !en.isIntersecting && en.boundingClientRect.top < 0); }); }).observe(mainBtn);
      var sb = sticky.querySelector('button');
      if (sb) sb.addEventListener('click', function(){ if (typeof form.requestSubmit === 'function') form.requestSubmit(); else form.submit(); });
    }
  });
})();
